<template>
    <div>
        <div v-if="loading" class="text-center" style="padding: 40px 0;">
            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
        </div>
        <div v-else>
            <div class="row mb-2" v-if="twilights.length > 0">
                <div class="col-md-5">
                    <div class="card w-100 margin-botton-20 border-0" style="width: 18rem;">
                        <div class="card-body border-primary">
                            <h3 class="h5 card-title">Periods</h3>
                            <p class="card-text"><TwilightGraph :datalist="twilightDatalist" :types="twilightTypes" :now-angle-deg="nowAngleDeg" /></p>
                            <p v-if="currentPeriodLabel" class="card-text">
                                <span class="badge" :class="currentPeriodBadgeClass">{{ currentPeriodLabel }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="row margin-botton-20" style="margin-top: 20px;">
                        <div class="col-md-12">
                            <div class="row themed">
                                <div class="col-md-6">Astronomical Twilight:</div>
                                <div class="col-md-6">{{ twilightByType[1] && twilightByType[1][0] && twilightByType[1][0].time }} / {{ twilightByType[1] && twilightByType[1][1] && twilightByType[1][1].time }}</div>
                            </div>
                            <div class="row themed">
                                <div class="col-md-6">Nautical Twilight:</div>
                                <div class="col-md-6">{{ twilightByType[2] && twilightByType[2][0] && twilightByType[2][0].time }} / {{ twilightByType[2] && twilightByType[2][1] && twilightByType[2][1].time }}</div>
                            </div>
                            <div class="row themed">
                                <div class="col-md-6">Civil Twilight:</div>
                                <div class="col-md-6">{{ twilightByType[3] && twilightByType[3][0] && twilightByType[3][0].time }} / {{ twilightByType[3] && twilightByType[3][1] && twilightByType[3][1].time }}</div>
                            </div>
                            <div class="row themed">
                                <div class="col-md-6">When:</div>
                                <div class="col-md-6" v-if="twilights[0]">{{ twilights[0].naturalday }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3" v-for="event in orderedTwilights" :key="event.id">
                    <div class="card w-100" style="width: 18rem; margin-bottom: 20px;">
                        <div class="card-body event-card-bg">
                            <h3 class="h5 card-title">{{ event.name }}</h3>
                            <p class="card-text">
                                <img :src="twilightIcon(event.type)" style="height:25px;" />
                            </p>
                            <p class="card-text">{{ event.naturalday }} at {{ event.time }}</p>
                            <p class="card-text small">{{ event.naturaltime }}</p>
                            <p class="card-text small">Duration {{ event.duration_minutes }} min.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2 mt-3" v-if="twilights.length > 0">
                <div class="col-12">
                    <TwilightBarChart :twilights="twilights" title="Twilight Times" :subtitle="chartSubtitle" :subtitle2="chartSubtitle2" />
                </div>
            </div>
            <div class="row mt-3" v-if="twilightMonthlyRows.length">
                <div class="col-12">
                    <div class="card w-100 margin-botton-20">
                        <div class="card-body event-card-bg">
                            <h3 class="h4 card-title mb-3">{{ currentMonthLabel }}</h3>
                            <div class="mb-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="twCivil" value="civil" v-model="selectedTwilightType">
                                    <label class="form-check-label" for="twCivil">Civil</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="twNautical" value="nautical" v-model="selectedTwilightType">
                                    <label class="form-check-label" for="twNautical">Nautical</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="twAstro" value="astronomical" v-model="selectedTwilightType">
                                    <label class="form-check-label" for="twAstro">Astronomical</label>
                                </div>
                            </div>
                            <div class="table-responsive">
                            <table class="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th>Morning</th>
                                        <th>Evening</th>
                                        <th>Duration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in twilightMonthlyFiltered" :key="row.date"
                                        :class="{ 'table-success': date && parseInt(row.date) === date.getDate() }"
                                        :style="date && parseInt(row.date) === date.getDate() ? { '--bs-table-bg': 'rgba(25,135,84,0.15)', '--bs-table-border-color': 'transparent' } : {}">
                                        <td>{{ row.date }}</td>
                                        <td>{{ row.morning }}</td>
                                        <td>{{ row.evening }}</td>
                                        <td>{{ row.duration }} min</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import astroTabMixin from '@/mixins/astroTab'
import astra from '@/api/astra'
import TwilightBarChart from './TwilightBarChart'
import TwilightGraph from './TwilightGraph'

const TWILIGHT_ICONS = { 0: 'night', 1: 'astronomical', 2: 'nautical', 3: 'civil', 4: 'day' }

export default {
    name: 'TabTwilight',
    mixins: [astroTabMixin],
    components: { TwilightBarChart, TwilightGraph },
    props: {
        active: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            twilights: [],
            twilightsMonthly: [],
            selectedTwilightType: 'civil',
        }
    },
    computed: {
        chartSubtitle() {
            if (!this.city || !this.city.name) return ''
            const parts = [this.city.name]
            if (this.city.region_name) parts.push(this.city.region_name)
            return 'near ' + parts.join(', ')
        },
        chartSubtitle2() {
            if (!this.date) return ''
            return 'for ' + this.date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
        },
        twilightDatalist() {
            return this.twilights.map(t => t.duration_minutes)
        },
        twilightTypes() {
            return this.twilights.map(t => t.type)
        },
        twilightByType() {
            const grouped = {}
            for (const t of this.twilights) {
                if (!grouped[t.type]) grouped[t.type] = []
                grouped[t.type].push(t)
            }
            return grouped
        },
        currentPeriodLabel() {
            if (!this.time || this.twilights.length < 8) return null
            const now = this.time.getHours() * 60 + this.time.getMinutes()
            const starts = this.twilights.map(t => this.parseTimeMin(t.time))
            let idx = 7
            for (let i = 0; i < starts.length; i++) {
                if (starts[i] !== null && now >= starts[i]) idx = i
            }
            const LABELS = { 0: 'Night', 1: 'Astronomical Twilight', 2: 'Nautical Twilight', 3: 'Civil Twilight', 4: 'Day' }
            return LABELS[this.twilights[idx].type] || null
        },
        nowAngleDeg() {
            if (!this.time || this.twilights.length < 8) return null
            const total = this.twilights.reduce((s, t) => s + t.duration_minutes, 0)
            if (!total) return null
            const startMin = this.parseTimeMin(this.twilights[0].time)
            if (startMin === null) return null
            const nowMin = this.time.getHours() * 60 + this.time.getMinutes()
            const offset = (nowMin - startMin + 1440) % 1440
            return -90 + (offset / total) * 360
        },
        currentPeriodBadgeClass() {
            if (this.currentPeriodLabel === 'Day') return 'bg-warning text-dark'
            if (this.currentPeriodLabel === 'Night') return 'bg-dark text-white'
            return 'bg-secondary text-white'
        },
        orderedTwilights() {
            return [...this.twilights].reverse()
        },
        twilightMonthlyRows() {
            const byDate = {}
            for (const event of this.twilightsMonthly) {
                if (!byDate[event.short_date]) byDate[event.short_date] = []
                byDate[event.short_date].push(event)
            }
            return Object.entries(byDate).map(([date, events]) => {
                const astro  = events.filter(e => e.name === 'Astronomical Twilight')
                const naut   = events.filter(e => e.name === 'Nautical Twilight')
                const civil  = events.filter(e => e.name === 'Civil Twilight')
                return {
                    date:          date.split('-')[2],
                    astroMorn:     astro[0]  ? astro[0].time             : '—',
                    nautMorn:      naut[0]   ? naut[0].time              : '—',
                    civilMorn:     civil[0]  ? civil[0].time             : '—',
                    civilEve:      civil[1]  ? civil[1].time             : '—',
                    nautEve:       naut[1]   ? naut[1].time              : '—',
                    astroEve:      astro[1]  ? astro[1].time             : '—',
                    astroDuration: astro[0]  ? astro[0].duration_minutes : '—',
                    nautDuration:  naut[0]   ? naut[0].duration_minutes  : '—',
                    civilDuration: civil[0]  ? civil[0].duration_minutes : '—',
                }
            })
        },
        twilightMonthlyFiltered() {
            const key = this.selectedTwilightType
            return this.twilightMonthlyRows.map(row => ({
                date:     row.date,
                morning:  key === 'astronomical' ? row.astroMorn     : key === 'nautical' ? row.nautMorn     : row.civilMorn,
                evening:  key === 'astronomical' ? row.astroEve      : key === 'nautical' ? row.nautEve      : row.civilEve,
                duration: key === 'astronomical' ? row.astroDuration : key === 'nautical' ? row.nautDuration : row.civilDuration,
            }))
        },
    },
    watch: {
        active(val) { if (val) this.load() },
        city()      { if (this.active) this.load() },
        date()      { if (this.active) this.load() },
    },
    mounted() {
        if (this.active) this.load()
    },
    methods: {
        parseTimeMin(str) {
            if (!str) return null
            const lower = str.toLowerCase().trim()
            const isPm = lower.includes('pm')
            const isAm = lower.includes('am')
            const [h, m] = lower.replace(/[apm\s]/g, '').split(':').map(Number)
            let hours = h
            if (isPm && h !== 12) hours += 12
            if (isAm && h === 12) hours = 0
            return hours * 60 + (m || 0)
        },
        twilightIcon(type) {
            return `images/twilight/${TWILIGHT_ICONS[type] || 'day'}.png`
        },
        async load() {
            if (!this.latitude || !this.longitude || !this.timezone) return
            if (this.apiLocked) return
            this.loading = true
            await Promise.allSettled([
                astra.fetchTwilight({ ...this.loc, ...this.dailyRange }).then(r => { this.twilights = r.data.events }),
                astra.fetchTwilight({ ...this.loc, ...this.monthlyRange }).then(r => { this.twilightsMonthly = r.data.events }),
            ])
            this.loading = false
        },
    },
}
</script>

<style scoped>
.themed {
    margin: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding-bottom: 10px;
    padding-top: 10px;
}
.margin-botton-20 { margin-bottom: 20px; }
.table-responsive td,
.table-responsive th { white-space: nowrap; }
</style>
